import {Map, ObjectManager, YMaps} from 'react-yandex-maps';
import {useContext, useEffect, useRef, useState} from "react";
import {GlobalContext} from "../../../GlobalReducer";
import {ShopInterface} from "../../../interfaces/shop/ShopInterface";
import {MOSCOW_REGION_ID, SPB_REGION_ID} from "../../../Config";
import {useNavigate} from "react-router-dom";

const DEFAULT_ZOOM = 12;
const LARGE_ZOOM = 10;
const SUPER_LARGE_ZOOM = 5;

let lastMapUid: any = null;

const CATEGORY_ICONS = {
    'Флагманский магазин': '/img/svg/mapIcon1.svg',
    'Фирменный магазин': '/img/svg/mapIcon2.svg', 
    'Франчайзи': '/img/svg/mapIcon3.svg',
    'Корнер': '/img/svg/mapIcon4.svg',
    'Аутлет/Дисконт': '/img/svg/mapIcon5.svg'
} as const;

const getCategoryIcon = (categoryName: string): string => {
    return CATEGORY_ICONS[categoryName as keyof typeof CATEGORY_ICONS] || '/img/svg/mapIcon1.svg';
};

export default function ShopMap({shops, allShopVisible}: { shops: ShopInterface[], allShopVisible: boolean }) {
    const mapRef: any = useRef(null);

    const navigate = useNavigate()

    /* eslint-disable no-unused-vars */
    const [state, dispatch] = useContext(GlobalContext);

    const [centerOfMap, setCenterOfMap] = useState<any>(null)
    const [zoom, setZoom] = useState<number>(DEFAULT_ZOOM)

    const [features, setFeatures] = useState<any>({
        "type": "FeatureCollection",
        "features": []
    })

    const [originalIcons, setOriginalIcons] = useState<{[key: string]: string}>({})

    useEffect(() => {
        if (!shops.length) return

        let shopsFiltered = shops.filter((shop) => {
            return (parseFloat(shop.extra_param.longitude) > 0 || parseFloat(shop.longitude) > 0) && (parseFloat(shop.extra_param.latitude) > 0 || parseFloat(shop.latitude) > 0);
        })

        if (shopsFiltered.length) {
            const centerCoordinate = [parseFloat(shopsFiltered[0].extra_param.longitude) > 0 ? shopsFiltered[0].extra_param.longitude : shopsFiltered[0].longitude, parseFloat(shopsFiltered[0].extra_param.latitude) > 0 ? shopsFiltered[0].extra_param.latitude : shopsFiltered[0].latitude]

            setCenterOfMap(shopsFiltered?.length > 0 && centerCoordinate)
            switch(true){
                case shopsFiltered[0].region.id == MOSCOW_REGION_ID || shopsFiltered[0].region.id == SPB_REGION_ID:
                    setZoom(LARGE_ZOOM);
                    break;
                case allShopVisible:
                    setZoom(SUPER_LARGE_ZOOM);
                    break;
                default:
                    setZoom(DEFAULT_ZOOM);
            }
        }

        const iconsMap: {[key: string]: string} = {}

        const featuresData: any = shopsFiltered.map(shop => {
            const categoryIcon = getCategoryIcon(shop.extra_param.category_name);
            iconsMap[shop.id] = categoryIcon;
            
            return {
                type: "Feature",
                id: shop.id,
                geometry: {
                    type: "Point",
                    coordinates: [parseFloat(shop.extra_param.longitude) > 0 ? shop.extra_param.longitude : shop.longitude, parseFloat(shop.extra_param.latitude) > 0 ? shop.extra_param.latitude : shop.latitude]
                },
                properties: {
                    hintContent: (shop.extra_param.address + shop.extra_param.address2) || shop.address,
                    categoryName: shop.extra_param.category_name
                },
                options: {
                    iconLayout: 'default#image',
                    iconImageHref: categoryIcon,
                    iconImageSize: [75, 75],
                    iconImageOffset: [-16, -16]
                }
            }
        })

        setOriginalIcons(iconsMap)
        setFeatures({
            "type": "FeatureCollection",
            "features": featuresData
        })
    }, [shops])


    return (<>
        {centerOfMap && <div className="col-lg-8 shops__map-iframe">
            <YMaps>
                <Map state={{center: centerOfMap, zoom: zoom}} width={"100%"} height={'100%'}>
                    <ObjectManager
                        options={{
                            clusterize: true,
                        }}
                        objects={{
                            openBalloonOnClick: true,
                            preset: 'islands#fashionIcon',
                        }}
                        // @ts-ignore
                        features={features}
                        clusters={{
                            preset: 'islands#invertedBlackClusterIcons',
                        }}
                        modules={[
                            'objectManager.addon.objectsHint',
                        ]}
                        instanceRef={ref => mapRef.current = ref}
                        onLoad={() => {
                            if (lastMapUid && originalIcons[lastMapUid]) {
                                mapRef.current.objects.setObjectOptions(lastMapUid, {
                                    iconLayout: 'default#image',
                                    iconImageHref: originalIcons[lastMapUid],
                                    iconImageSize: [75, 75],
                                    iconImageOffset: [-16, -16]
                                });
                            }
                            mapRef.current.objects.events.add('click', (e: any) => {
                                const objectId = e.get('objectId');
                                if (lastMapUid && originalIcons[lastMapUid]) {
                                    mapRef.current.objects.setObjectOptions(lastMapUid, {
                                        iconLayout: 'default#image',
                                        iconImageHref: originalIcons[lastMapUid],
                                        iconImageSize: [75, 75],
                                        iconImageOffset: [-16, -16]
                                    });
                                }
                                lastMapUid = objectId
                                mapRef.current.objects.setObjectOptions(objectId, {
                                    iconLayout: 'default#image',
                                    iconImageHref: originalIcons[objectId],
                                    iconImageSize: [75, 75],
                                    iconImageOffset: [-20, -20]
                                })
                                navigate('/shop/' + objectId)
                            })
                        }}
                    >

                    </ObjectManager>
                </Map>
            </YMaps>
        </div>}
    </>)
}